export const GROPUS = {
  BASE: 'base',
  POPULAR: 'popular',
  EXTRAS: 'extra',
  DETAILING: 'detailing',
  SURCHARGE: 'surcharge'
}
